module.exports = __webpack_public_path__ + "bc7cc625d20cf0812c3ac5e70216748a.jpg";